module.exports = __webpack_public_path__ + "static/img/Kiitoskortti_Avecor_katri-martiskainen_A4.f0c0082.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/salesperson-leaflets/Kiitoskortti_Avecor_katri-martiskainen_A4.pdf
// module id = e8iw
// module chunks = 22